module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/coj_e-3-f7c9d97aab54b3a40c0be1f85c5f8359.jpg";